import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualConfigPage } from './manual-config.page';

const routes: Routes = [
  {
    path: '',
    component: ManualConfigPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualConfigPageRoutingModule {}
